/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Sonstige12Inputs */

const en__field_enum_tuda_sonstige12 = /** @type {(inputs: _Field_Enum_Tuda_Sonstige12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const de__field_enum_tuda_sonstige12 = /** @type {(inputs: _Field_Enum_Tuda_Sonstige12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstige`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {_Field_Enum_Tuda_Sonstige12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_sonstige12 = /** @type {((inputs?: _Field_Enum_Tuda_Sonstige12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Sonstige12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_sonstige12(inputs)
	return de__field_enum_tuda_sonstige12(inputs)
});
export { _field_enum_tuda_sonstige12 as "_field_enum_TUDA_SONSTIGE" }